import { SiteHeader } from "../components/site-header"

export function PrivacyPage() {
  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="simple-page legal-copy">
        <div className="eyebrow">Privacy</div>
        <h1>Privacy policy</h1>
        <p>Effective date: April 28, 2026</p>

        <h2>1. Scope</h2>
        <p>
          This Privacy Policy describes how Adgiro collects, uses, stores, discloses, and protects
          information in connection with the Adgiro website, application, connected advertising
          accounts, analytics services, and related support and operational services.
        </p>

        <h2>2. Categories of information</h2>
        <p>Adgiro may collect and process the following categories of information:</p>
        <ul className="legal-list">
          <li>
            Account and profile information, including name, email address, company name, and
            billing details.
          </li>
          <li>
            Authentication and authorization data, including OAuth tokens, scope grants, expiry
            data, and connected account metadata.
          </li>
          <li>
            Advertising account data, including account identifiers, campaign objects, budgets,
            creative metadata, reporting data, and performance statistics.
          </li>
          <li>
            Website and conversion data, including page events, conversion events, referral data,
            campaign parameters, click identifiers, and related measurement metadata.
          </li>
          <li>
            Device, log, and usage data, including IP address, browser information, request logs,
            session data, and application activity records.
          </li>
          <li>
            Support and communications data, including messages, feedback, service requests, and
            operational correspondence.
          </li>
        </ul>

        <h2>3. Sources of information</h2>
        <p>
          Adgiro may receive information directly from customers, from connected Google and Meta
          services, from customer websites and tracking implementations, from payment and
          infrastructure providers, and from routine operation of the Adgiro website and
          application.
        </p>

        <h2>4. Purposes of processing</h2>
        <p>Adgiro uses information for business and commercial purposes that include:</p>
        <ul className="legal-list">
          <li>Provision, operation, maintenance, and improvement of the service.</li>
          <li>Authentication, account administration, access control, and workspace management.</li>
          <li>Connection to advertising, analytics, and measurement platforms.</li>
          <li>
            Campaign creation, campaign management, conversion forwarding, reporting, and
            optimization.
          </li>
          <li>
            Customer support, service communications, product analytics, fraud prevention, abuse
            monitoring, security review, and legal compliance.
          </li>
        </ul>

        <h2>5. Disclosures concerning connected platform data</h2>
        <p>
          Where Adgiro accesses data from Google API Services or Meta platform services, Adgiro uses
          that data solely for the customer-facing features, operational workflows, security
          functions, support functions, and compliance functions described in this Privacy Policy
          and in the application interface. Data access, use, storage, and sharing practices are
          governed by the permissions granted by the customer and by the applicable platform terms
          and policies.
        </p>

        <h2>6. Disclosure of information</h2>
        <p>Adgiro may disclose information to the following categories of recipients:</p>
        <ul className="legal-list">
          <li>
            Service providers and subprocessors that support hosting, storage, analytics,
            communications, billing, security, and infrastructure operations.
          </li>
          <li>
            Integrated platforms and providers selected or authorized by the customer, including
            advertising and analytics services.
          </li>
          <li>
            Professional advisers, auditors, insurers, and financing or transaction counterparties
            in connection with business operations.
          </li>
          <li>
            Governmental authorities, courts, regulators, or other parties where disclosure is
            appropriate to comply with law, enforce rights, or protect users, Adgiro, or the public.
          </li>
        </ul>

        <h2>7. Data retention</h2>
        <p>
          Adgiro retains information for the period reasonably necessary to provide the service,
          maintain records, resolve disputes, enforce agreements, satisfy legal obligations, and
          support legitimate business operations. Retention periods may vary by data category,
          contractual requirements, and operational need.
        </p>

        <h2>8. Security</h2>
        <p>
          Adgiro uses administrative, technical, and organizational safeguards designed to protect
          information from unauthorized access, alteration, disclosure, or destruction. Security
          measures may include encryption, access controls, credential management, logging,
          monitoring, and environment-level protections.
        </p>

        <h2>9. International processing</h2>
        <p>
          Information may be processed in the United States and in other jurisdictions where Adgiro,
          its service providers, or its infrastructure providers operate. Those jurisdictions may
          apply data protection rules that differ from the rules in a customer’s home jurisdiction.
        </p>

        <h2>10. Customer choices and rights</h2>
        <p>
          Depending on applicable law, customers may have rights relating to access, correction,
          deletion, export, restriction, objection, or withdrawal of consent. Adgiro may require
          verification of identity and authority before acting on a request.
        </p>

        <h2 id="data-deletion-instructions">11. Data deletion instructions</h2>
        <p>
          Customers may request deletion of Adgiro account data and connected platform data by
          sending a deletion request through the support contact identified in the Adgiro
          application or company materials and by identifying the relevant workspace, account email,
          and connected platform account where applicable.
        </p>
        <p>
          Upon receipt of a verified request, Adgiro will review the request, confirm account
          authority, revoke connected platform access where applicable, and delete or de-identify
          data that Adgiro is not required to retain for security, fraud prevention, billing,
          dispute resolution, audit, or legal compliance purposes.
        </p>
        <p>
          Customers may also disconnect Adgiro from Google or Meta directly through the applicable
          platform account permission settings. Disconnecting a platform stops future access, but a
          separate deletion request may still be required to remove retained Adgiro records that are
          associated with the workspace.
        </p>

        <h2>12. Changes to this policy</h2>
        <p>
          Adgiro may update this Privacy Policy from time to time. Updated versions may be posted on
          this page together with a revised effective date.
        </p>

        <h2>13. Contact</h2>
        <p>
          Questions regarding this Privacy Policy may be directed to the contact address identified
          in the Adgiro application or company materials.
        </p>
      </main>
    </div>
  )
}
